export const formatAmount = (amount) =>
  new Intl.NumberFormat("es-AR").format(amount);

export default {};
